import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteVermerkCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteVermerkCommandService],
  exports: []
})
export class DeleteVermerkCommandServiceModule { }
